import React, { useEffect, useMemo, useState } from 'react';
import Moment from 'moment-jalaali';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getQueryString } from "../../../utils/functions";
import Signature from '../../master/Signature';
import { useTranslation } from 'react-i18next';

export default function ReportButtons({ report }) {
    const { t } = useTranslation();
    const { user } = useSelector((store) => store);

    const [openSignatureModal, setOpenSignatureModal] = useState(getQueryString('open-sign'));
    const [signName, setSignName] = useState(null);
    const [signs, setSigns] = useState({
        approve: null,
        reject: null,
    });
    const [userStatus, setUserStatus] = useState(null);

    useEffect(() => {
        if (!report.id) return;
        setUserStatus(report.user_status);
        setSigns({
            approve: report.attachments.find(img => img.filename.includes('sign_image'))?.created_at,
            reject: report.attachments.find(img => img.filename.includes('cancel_sign'))?.created_at,
        });
    }, [report]);

    const renderButton = useMemo(() => {
        const { accident, losses } = report;
        if (user.type === 'user') {
            switch (userStatus) {
                case 0:
                    if ((accident.insurance_type === 'body' || losses.user.id === user.id) && [1, 5].includes(report.status)) {
                        return (
                            <>
                                <button
                                    className='btn btn-green btn-circle-right flex1'
                                    onClick={() => {
                                        setSignName('sign_image');
                                        setOpenSignatureModal(true);
                                    }}
                                >
                                    {t('Confirm and get the money')}
                                </button>
                                <button
                                    className='btn btn-red btn-circle-left flex1'
                                    onClick={() => {
                                        setSignName('cancel_sign');
                                        setOpenSignatureModal(true);
                                    }}
                                >
                                    {t('Cancle get money')}
                                </button>
                            </>
                        );
                    }
                    break;
                case 1:
                    return (
                        <p className='text-center flex1'>
                            {/* پرونده در تاریخ
                            {` ${Moment(signs.approve).format('jYYYY/jM/jD')} `}
                            توسط زیاندیده تایید شده است */}
                            {t('Confirm report message',{date:Moment(signs.approve).format('jYYYY/jM/jD')})}
                        </p>
                    );
                case 2:
                    return (
                        <p className='text-center flex1'>
                            {/* شما در تاریخ
                            {` ${Moment(signs.reject).format('jYYYY/jM/jD')} `}
                            از دریافت خسارت انصراف دادید */}
                            {t('Cancle report message',{date:Moment(signs.reject).format('jYYYY/jM/jD')})}
                        </p>
                    );
                default: return null;
            }
        }
        else {
            switch (report.status) {
                case -10:
                    return report.complements.length === 0|| report.archives.length === 0 ? <Link to='/edit-report' className='btn btn-orange flex1 btn-circle'>{t('Edit')}</Link> : null;
                case 3:
                    return <Link to='/review' className='btn btn-red flex1 btn-circle'>{t('Health visit')}</Link>;
                case 6:
                    return <Link to='/review' className='btn btn-red flex1 btn-circle'>{t('Give damage accessories')}</Link>;
                case 10:
                    return <Link to='/review' className='btn btn-red flex1 btn-circle'>{t('Archives list')}</Link>;
                default:
                    return null;
            }
        }
    }, [report, signs, user, userStatus]);


    function closeSign(res) {
        if (res) {
            setUserStatus(signName === 'sign_image' ? 1 : 2);
            if (res.filename === 'sign_image') setSigns(prevState => ({...prevState, approve: res.created_at}));
            else setSigns(prevState => ({...prevState, reject: res.created_at}));
            setOpenSignatureModal(false);
        } else setOpenSignatureModal(false);
    }

    return (
        <div className='d-flex flex-row-reverse mt20' style={{width:'50%', margin:'auto'}}>
            <Signature
                open={openSignatureModal}
                close={closeSign}
                reportId={report.id}
                name={signName}
            />
            { renderButton }
        </div>
    );
}
